/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited
// @ts-nocheck


import { DEFAULT_SIZE, type IconProps } from '../../npmlib-icons/src/types';


export const SaveWhenIGetPaid = ({ color = 'currentColor', size = DEFAULT_SIZE, ...props }: IconProps) => {
        return (
                <svg
                    width={size}
                    height={size}
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    {...props}>
                    <path
                        d="M21.1049 10.6056L22 11.7582L12 20L2 11.7582L2.89511 10.6056L12 18.1091L21.1049 10.6056ZM12.7164 3V4.08646C14.1149 4.29903 15.0434 5.22016 15.1351 6.57823H13.622C13.5188 5.95233 12.9686 5.43272 12.086 5.43272C11.2721 5.43272 10.7907 5.77519 10.7907 6.36566C10.7907 6.88527 11.1575 7.13327 11.7192 7.2986L13.0718 7.68831C14.2295 8.03078 15.2154 8.59763 15.2154 10.2391C15.2154 11.5972 14.2525 12.5301 12.7164 12.7073V13.8882H11.4326V12.6718C9.98826 12.412 8.99098 11.3374 8.89928 9.77856H10.4124C10.4812 10.6761 11.2263 11.361 12.1662 11.361C13.0489 11.361 13.6564 10.9241 13.6564 10.2746C13.6564 9.69589 13.2323 9.36523 12.6591 9.1999L11.3065 8.81019C10.1717 8.47953 9.22024 7.87726 9.22024 6.37747C9.22024 5.19654 10.1143 4.31084 11.4326 4.08646V3H12.7164Z"
                        fill={color}
                    />
                </svg>
        );
    };
